var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{class:("d-flex justify-center " + (_vm.theme.dark ? '' : _vm.theme.color)),attrs:{"flat":""}},[_c('LighterTextField',{attrs:{"title":_vm.text.length > 0
        ? _vm.text
        : 'O Formulário aparecerá aqui assim que carregá-lo no menu principal.',"subtitle":"","comment":"","text":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }